import Departments from '../../views/Departments';

export default function DepartmentsPage() {
  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <Departments />
    </div>
  );
}
